<script setup lang="ts">
import { PencilLineIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag, UITextMdMedium } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium class="text-base font-semibold">
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        <template v-if="data?.metaData?.email"
          >({{ data.metaData.email }})</template
        >
      </span>
      <span class="text-gray-800" v-else>{{ data.metaData.email }}</span>
      <span class="text-gray-500 ml-1">
        {{ t('proposalsList.eventLogs.editedTitle') }}
      </span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-3">
    <p class="text-md text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="info" size="medium" class="text-[8px] updated-event">
      <template #icon> <PencilLineIcon class="w-4 h-4 pencil-icon" /></template>
      {{ t('proposalsList.eventLogs.edited') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.updated-event {
  --n-text-color: rgb(29 78 216) !important;
  --n-color: rgb(239 246 255) !important;
  --n-border: 0px !important;
}
.pencil-icon {
  color: rgb(59 130 246) !important;
}
</style>
